/*import Vue from 'vue'*/
import EventUtils from '@/utils/EventUtils.js';
import MapUtils from '@/utils/MapUtils.js';
import ConstUtils from '@/utils/ConstUtils.js'

const state = {
  list: [],
  map: {},
};

const getters = {
  EquipmentStorage: state => state,
  EquipmentStorage_size: state => state.list.length,
};

const actions = {
};

const mutations = {
  SOCKET_ONMESSAGE (state, event)  {
    if (event.status == EventUtils.STATUS.COMPLETE && event.statusCode == EventUtils.CODE.OK) {
      if (event.Payload && event.Payload.EquipmentMap) {
        var items = event.Payload.EquipmentMap;
        state.map = MapUtils.updateMap(items, state.map);
        state.list = Object.values(state.map);
      }
      if (event.Payload && event.Payload.Equipment) {
        var obj = event.Payload.Equipment;
        state.map[obj[ConstUtils.FIELDS.ID]] = obj;
        state.list = Object.values(state.map);
      }
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};